@use '../../sass/theme';

$colors: success, info, warning, danger, high, low;

.alert-block {
  font-family: var(--jui-font-family);
  border-radius: var(--jui-btn-border-radius);
  display: flex;
  flex-direction: row;
  position: relative;
  font-size: var(--jds-base-fs-300);
  font-weight: var(--jds-base-fw-400);
  line-height: normal;
  margin: var(--jds-space-sm) 0 var(--jds-space-sm) 0;

  @each $color in $colors {
    &--#{$color} {
      --bg-color: var(--jui-alert-block-bg-#{$color});
      --fg-color: var(--jui-alert-block-contrast-#{$color});
      background-color: var(--jui-alert-block-bg-#{$color});
      border: 1px solid var(--jui-alert-block-border-#{$color});
      color: var(--jui-alert-block-contrast-#{$color});
    }
  }

  &--hiding {
    animation: hide 250ms forwards;
  }

  &__main {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__text-content {
    padding: var(--jds-space-inset-squish);
    flex-grow: 1;
  }

  &__icon {
    line-height: 1.1;
    display: flex;
    justify-content: center;
    width: 40px;
    align-items: center;
    color: var(--bg-color);
    background-color: var(--fg-color);
    border-top-left-radius: var(--jui-btn-border-radius);
    border-bottom-left-radius: var(--jui-btn-border-radius);

    &--clear {
      color: var(--fg-color);
      background-color: unset;
    }
  }

  &__title {
    font-weight: 600;
    margin: var(--jds-space-stack-xs);
  }

  &--sm {
    font-size: var(--jds-base-fs-200);
    & .alert-block__text-content {
      padding: var(--jds-space-inset-squish-sm);
    }

    & .alert-block__icon {
      width: 30px;
    }

    & .alert-block__title {
      margin: var(--jds-space-stack-xxs);
    }
  }

  &--lg {
    font-size: var(--jds-base-fs-400);

    & .alert-block__icon {
      width: 50px;
    }
  }

  &--margin-md {
    margin: var(--jds-space-lg) 0 var(--jds-space-lg) 0;
  }

  &--margin-lg {
    margin: var(--jds-space-xl) 0 var(--jds-space-xl) 0;
  }

  &--margin-none {
    margin: 0;
  }
}

@keyframes hide {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
